import { useContext, useState } from "react";
import { useCreateAudience } from "../../../../../hooks/api/mutations/useMarketing";
import { ToastContext } from "../../../../../hooks/context";

export const useAudienceForm = ({ closeModal = () => {} }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    customer_ids: [],
    exclude_customer_ids: [],
    select_all_customers: false,
  });
  const [isCustomerView, setIsCustomerView] = useState(false);
  const triggerToast = useContext(ToastContext);
  const { mutate: createAudience, isLoading } = useCreateAudience();

  const handleSubmitAudience = () => {
    createAudience(formData, {
      onSuccess: () => {
        triggerToast("Audience group creation successful", "success");
        closeModal();
      },
    });
  };

  return {
    isLoading,
    formData,
    isCustomerView,
    setIsCustomerView,
    setFormData,
    handleSubmitAudience,
  };
};
